import { Configuration, InteractionRequiredAuthError, PopupRequest, PublicClientApplication } from "@azure/msal-browser";


export const AUTH_HEADER = "X-MELLON-AUTHORIZATION";

const AUTHORITY = process.env.REACT_APP_AUTHORITY;

export const MSAL_CONFIG: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
        knownAuthorities: [AUTHORITY]
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
    system: {
        tokenRenewalOffsetSeconds: 600
    }
}

export const AZURE_SCOPES = ["User.Read", "email"];

export const loginRequest: PopupRequest = {
    scopes: AZURE_SCOPES,
};

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);

export const getToken = async () => {
    const account = msalInstance.getActiveAccount();
    
    if (!account) {
        throw new Error("No active user account found");
    }

    const request = {
        scopes: AZURE_SCOPES, 
        account: account,
        refreshTokenExpirationOffsetSeconds: 600
    };

    try {
        const response = await msalInstance.acquireTokenSilent(request);
        return `Bearer ${response.idToken}`;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            console.warn("Silent token refresh failed. User interaction is required.");
            
            const response = await msalInstance.acquireTokenPopup(request);
            return `Bearer ${response.idToken}`;
        }

        throw error;
    }
};